// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3FnuS","title":"Header_title__3I4uA","left":"Header_left__48VL5","clinicName":"Header_clinicName__3KMJZ"};